import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

export default class DIApi extends BaseAPI {
  apiName = 'DI';

  /**
   * Theo dõi/Ngưng theo dõi
   */
  quickUpdateFollowState(param) {
    const request = {
      url: this.getAPIUrl() + '/followState',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu danh mục
   */
  UpdateTranferData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}
